import { render, staticRenderFns } from "./AgreementModal.vue?vue&type=template&id=8352848c&scoped=true&"
import script from "./AgreementModal.vue?vue&type=script&lang=js&"
export * from "./AgreementModal.vue?vue&type=script&lang=js&"
import style0 from "./AgreementModal.vue?vue&type=style&index=0&id=8352848c&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8352848c",
  null
  
)

export default component.exports